import { render, staticRenderFns } from "./ReactionIcon.vue?vue&type=template&id=3a36d850&scoped=true"
import script from "./ReactionIcon.vue?vue&type=script&lang=js"
export * from "./ReactionIcon.vue?vue&type=script&lang=js"
import style0 from "./ReactionIcon.vue?vue&type=style&index=0&id=3a36d850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a36d850",
  null
  
)

export default component.exports